var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view"},[_c('h2',[_vm._v("Vous n'avez pas le droit d'accéder à la page ou la ressource demandée (WIP)")])])}]

export { render, staticRenderFns }